import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { DosageFormatFragment } from "@shared/data/fragments";
import { DOSAGE_FORMAT_FRAGMENT } from "@shared/data/fragments";

const FORMS_QUERY = gql`
  query Forms_Shared_Query($sort: [DosageFormatSort!]) {
    viewer {
      forms(sort: $sort) {
        ...DosageFormatFragment
      }
    }
  }
  ${DOSAGE_FORMAT_FRAGMENT}
`;

interface FormsData {
  viewer: {
    forms: DosageFormatFragment[];
  };
}

type DIRECTION = "ASC" | "DESC";

interface Variables {
  sort: {
    direction: DIRECTION;
    field: "SUM_PRODUCTS_COUNT";
  };
}

const defaultVariables: Variables = {
  sort: {
    direction: "DESC",
    field: "SUM_PRODUCTS_COUNT",
  },
};

const useFormsQuery = (options?: QueryHookOptions<FormsData, Variables>) => {
  const { variables } = { variables: {}, ...options };

  return useQuery<FormsData, Variables>(FORMS_QUERY, {
    ...options,
    variables: { ...defaultVariables, ...variables },
  });
};

export type { FormsData };
export { useFormsQuery, FORMS_QUERY };
